<template>
    <div>
        <VillagesTopNav @leftIconFun="()=>{this.$router.go(-1);}">
            <h2 slot="content">我的帖子</h2>
        </VillagesTopNav>
        <div class="my-comment">
            <template v-for="item in newsData">
                <myPost :data="item"></myPost>
            </template>
        </div>
    </div>
</template>
<script>
    import VillagesTopNav from '../../components/VillagesTopNav.vue'
    import myPost from '../../components/myPost.vue'
    export default {
        components: {
            VillagesTopNav,
            myPost
        },
        data(){
            return {
                newsData:[{
                    title:"春雨滋润了美丽安阳。连日来，从广大党员干部、致富创业带头人到普通群众，大家认真学习、热议省委书记王国生。",
                    author:"飞翔的鸟",
                    time:"2019-12-10 8:45:12",
                    commentNum:"2",
                    imgList:[
                        {
                            imgSrc:"../assets/img/logo.png"
                        },
                        {
                            imgSrc:"../assets/img/logo.png"
                        }
                    ],
                    viewtNum:"3"
                },{
                    title:"我市广大党员干部群众认真学习、热议省委书记王国生在安调研讲话精神11",
                    author:"飞翔的鸟",
                    time:"2019-12-10 8:45:12",
                    commentNum:"2",
                    viewtNum:"3"
                }],
            }
        }
    }
</script>
<style scoped>
    h2{
        font-size:36px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:50px;
    }
</style>